export const SAMPLE_MARKDOWN = `# mdview에 오신 것을 환영합니다

마크다운을 좌측에 붙여넣거나 \`.md\` 파일을 끌어다 놓으세요. 우측에 즉시 렌더되고, 우상단 **PDF 다운로드** 버튼으로 인쇄용 PDF를 받을 수 있습니다.

## 무엇을 지원하나요

- 일반 마크다운 (제목, 굵게/기울임, 목록, 인용, 표, 링크)
- **KaTeX 수식** — 인라인 \`$x^2$\` 와 디스플레이
- **Mermaid 다이어그램** — 플로우차트, 시퀀스 등
- **코드 하이라이팅** — 14개 언어
- **한글 폰트 임베드** — PDF 안의 한글이 깨지지 않습니다

## 수식 예시

피타고라스 정리: $a^2 + b^2 = c^2$

이차방정식의 해:

$$x = \\frac{-b \\pm \\sqrt{b^2 - 4ac}}{2a}$$

정적분 예:

$$\\int_0^{\\pi} \\sin x \\, dx = 2$$

## 표

| 항목 | 클라이언트 | PDF |
|------|-----------|-----|
| 한글 본문 | ✅ | ✅ |
| 수식 (벡터) | ✅ | ✅ |
| 다이어그램 | ✅ | ✅ |
| 코드 하이라이팅 | ✅ | ✅ |

## 코드

\`\`\`ts
function greet(name: string): string {
  return \`안녕, \${name}!\`;
}

console.log(greet('정미애'));
\`\`\`

## 다이어그램

\`\`\`mermaid
graph LR
  사용자 -->|마크다운 입력| 에디터
  에디터 --> 렌더러
  렌더러 --> 프리뷰
  프리뷰 -->|PDF 다운로드| 인쇄
\`\`\`

## 인용

> 좋은 마크다운은 종이 위에서도 같은 모양이어야 한다.

---

이 텍스트를 지우고 본인의 마크다운을 입력해보세요. 새로고침해도 마지막 작성 내용은 자동으로 유지됩니다.
`;
